export const SEKTOR_YAPILANDIRMASI = {
  atolye_genel: { sektor: 'atolye', ad: 'Genel Atölye', basinc: 7.5, tuketim: '0.15-0.25', cig: 3, filtre: 'P+A', kurutucu: 'Soğutmalı', not: 'Standart pnömatik el aletleri, vidalama, temizlik.' },
  atolye_boya: { sektor: 'atolye', ad: 'Boya & Kaplama Atölyesi', basinc: 6.5, tuketim: '0.30-0.50', cig: -20, filtre: 'P+A+S', kurutucu: 'Soğutmalı', not: 'Nem/yağ kontrolü yüzey kalitesi için kritiktir.' },
  oto_binek: { sektor: 'otomotiv', ad: 'Binek Araç Montaj', basinc: 7.5, tuketim: '0.20-0.35', cig: 3, filtre: 'P+A', kurutucu: 'Soğutmalı', not: 'Montaj hatları, standart vidalama & test.' },
  oto_hafif: { sektor: 'otomotiv', ad: 'Kamyonet / Hafif Ticari', basinc: 8.5, tuketim: '0.35-0.55', cig: 3, filtre: 'P+A', kurutucu: 'Soğutmalı', not: 'Orta ölçekli presler, şasi montaj hatları.' },
  oto_agir: { setor: 'otomotiv', ad: 'Kamyon / Otobüs / Ağır Vasıta', basinc: 10, tuketim: '0.60-1.00', cig: 3, filtre: 'P+A+S', kurutucu: 'Soğutmalı', not: 'Fren testleri, büyük silindirler, yüksek torklu aletler.' },
  oto_boya: { sektor: 'otomotiv', ad: 'Otomotiv Boya Hattı', basinc: 8, tuketim: '0.80-1.50', cig: -40, filtre: 'P+A+S+U', kurutucu: 'Adsorpsiyon', not: 'ISO 8573-1 Class 1.2.1 standartları gereklidir.' },
  cnc_isleme: { sektor: 'cnc', ad: 'CNC Freze/Torna', basinc: 8, tuketim: '0.25-0.45', cig: -40, filtre: 'P+A+S', kurutucu: 'Adsorpsiyon', not: 'Takım ömrü ve yüzey pürüzlülüğü için kuru hava şart.' },
  cnc_lazer: { sektor: 'cnc', ad: 'Lazer & Plazma Kesim', basinc: 12, tuketim: '0.50-0.90', cig: -70, filtre: 'P+A+S+H', kurutucu: 'Adsorpsiyon', not: 'Lens koruma ve gaz saflığı için ultra kuru hava.' },
  gida_ambalaj: { sektor: 'gida', ad: 'Gıda Paketleme & Dolum', basinc: 7, tuketim: '0.40-0.80', cig: -20, filtre: 'P+A+S', kurutucu: 'Adsorpsiyon', not: 'Food-grade standartlar, yağsız hava (Class 0) önerilir.' },
  gida_hammadde: { sektor: 'gida', ad: 'Gıda İşleme & Hammadde', basinc: 7.5, tuketim: '0.30-0.60', cig: -40, filtre: 'P+A+S', kurutucu: 'Adsorpsiyon', not: 'Toz ve nem kontrolü ürün raf ömrü için kritiktir.' },
  tekstil_dokuma: { sektor: 'tekstil', ad: 'Dokuma & İplik', basinc: 8, tuketim: '0.30-0.60', cig: 3, filtre: 'P+A', kurutucu: 'Soğutmalı', not: 'Düşük nem, hava jetleri, pnömatik taraklar.' },
  tekstil_baski: { sektor: 'tekstil', ad: 'Baskı & Boyahane', basinc: 7, tuketim: '0.40-0.70', cig: -20, filtre: 'P+A+S', kurutucu: 'Soğutmalı', not: 'Kimyasal buhar ve nem ayrımı gereklidir.' },
  medikal_ilac: { sektor: 'medikal', ad: 'İlaç & Eczacılık', basinc: 7, tuketim: '0.20-0.50', cig: -70, filtre: 'P+A+S+H', kurutucu: 'Adsorpsiyon', not: 'USP Class VI / GMP, HEPA ve steril filtrasyon zorunlu.' },
  medikal_hastane: { sektor: 'medikal', ad: 'Hastane & Tıbbi Gazlar', basinc: 8, tuketim: '0.50-1.20', cig: -40, filtre: 'P+A+S+H', kurutucu: 'Adsorpsiyon', not: 'Kesintisiz çalışma, yedekli sistem gerektirir.' },
  enerji_santral: { sektor: 'enerji', ad: 'Termik / Rüzgar / Güneş Bakım', basinc: 10, tuketim: '0.60-1.50', cig: 3, filtre: 'P+A+S', kurutucu: 'Soğutmalı', not: 'Pnömatik valf kontrol, türbin temizliği.' },
  kimya_petrol: { sektor: 'kimya', ad: 'Kimya & Petrol Rafineri', basinc: 11, tuketim: '0.80-2.00', cig: -40, filtre: 'P+A+S', kurutucu: 'Adsorpsiyon', not: 'Ex-proof gereksinimi, inert gaz sistemleri.' },
  pet_sisme: { sektor: 'ozel', ad: 'PET Şişirme & Preform', basinc: 16, tuketim: '0.80-1.50', cig: -40, filtre: 'P+A+S', kurutucu: 'Adsorpsiyon', not: 'ISO 8573-1 Class 0 gereklidir. Yağsız kompresör + yüksek basınç tankı zorunludur.' },
  lazer_assist: { sektor: 'cnc', ad: 'Lazer Kesim Assist Gazı', basinc: 18, tuketim: '1.00-2.50', cig: -70, filtre: 'P+A+S+H', kurutucu: 'Adsorpsiyon', not: 'Ultra kuru hava (-70°C) ve yüksek saflık şart.' },
  hidrolik_test: { sektor: 'enerji', ad: 'Hidrolik & Basınç Test', basinc: 20, tuketim: '0.50-1.20', cig: 3, filtre: 'P+A', kurutucu: 'Soğutmalı', not: 'PED/ASME sertifikalı ekipman gerektirir.' },
  kompozit_kurek: { sektor: 'kimya', ad: 'Kompozit & Havacılık Kalıp', basinc: 16, tuketim: '0.60-1.80', cig: -40, filtre: 'P+A+S', kurutucu: 'Adsorpsiyon', not: 'Otoklav besleme hatları. Nem ve partikül kontrolü kritiktir.' }
};

export const getAltKategorilerBySektor = (sektorKey) => Object.entries(SEKTOR_YAPILANDIRMASI)
  .filter(([_, v]) => v.sektor === sektorKey)
  .map(([k, v]) => ({ key: k, ...v }));

export const SEKTOR_LISTESI = [...new Set(Object.values(SEKTOR_YAPILANDIRMASI).map(v => v.sektor))].map(k => {
  const o = Object.values(SEKTOR_YAPILANDIRMASI).find(v => v.sektor === k);
  return { key: k, ad: o.ad.split(' ')[0] };
});

export const REDUNDANCY_OPTIONS = [
  { value: 'otomatik', label: '🤖 Otomatik (Sistem Karar Verir)' },
  { value: 'tek', label: '🔘 Tek Kompresör' },
  { value: 'paralel', label: '⚡ Paralel Çalışma (Redundansız)' },
  { value: 'yedekli', label: '🛡️ Yedekli Sistem (N+1)' }
];

export const STANDART_KW = [7.5, 11, 15, 18.5, 22, 30, 37, 45, 55, 75, 90, 110, 132, 160, 200, 250, 315];
export const STANDART_TANKLAR = [200, 270, 500, 750, 1000, 1500, 2000, 3000, 4000, 5000, 7500, 10000, 15000, 20000];
export const STANDART_BORULAR_INCH = [1.0, 1.5, 2.0, 2.5, 3.0, 4.0, 5.0, 6.0];

export const FACTORS = { GUVENLIK: 1.2, KACAK: 1.1, VERIM: 0.72, TANK_SUREKLI: 0.6, TANK_ARALIKLI: 0.9, SAFETY_FACTOR_TANK: 1.25 };
export const UNLOAD_POWER_FACTOR_DEFAULT = 0.25;
export const EXTRA_LOSS = { filter: 0.3, dryer: 0.2, total: 0.5 };

export const PERFORMANCE_CURVES = {
  7.5:  { 7: 1.25, 8: 1.10, 10: 0.95, 12: 0.82, 15: 0.68, 20: 0.50 },
  11:   { 7: 1.85, 8: 1.65, 10: 1.45, 12: 1.28, 15: 1.05, 20: 0.78 },
  15:   { 7: 2.50, 8: 2.20, 10: 1.95, 12: 1.72, 15: 1.42, 20: 1.08 },
  22:   { 7: 3.70, 8: 3.30, 10: 2.90, 12: 2.55, 15: 2.12, 20: 1.60 },
  30:   { 7: 5.10, 8: 4.60, 10: 4.05, 12: 3.58, 15: 2.98, 20: 2.25 },
  37:   { 7: 6.30, 8: 5.70, 10: 5.00, 12: 4.42, 15: 3.68, 20: 2.78 },
  45:   { 7: 7.60, 8: 6.90, 10: 6.05, 12: 5.35, 15: 4.48, 20: 3.38 },
  55:   { 7: 9.30, 8: 8.40, 10: 7.40, 12: 6.55, 15: 5.48, 20: 4.15 },
  75:   { 7: 12.6, 8: 11.4, 10: 10.0, 12: 8.85, 15: 7.40, 20: 5.60 },
  90:   { 7: 15.2, 8: 13.8, 10: 12.1, 12: 10.7, 15: 8.95, 20: 6.80 },
  110:  { 7: 18.6, 8: 16.9, 10: 14.8, 12: 13.0, 15: 10.9, 20: 8.30 },
  132:  { 7: 22.4, 8: 20.3, 10: 17.8, 12: 15.7, 15: 13.2, 20: 10.0 },
  160:  { 7: 27.0, 8: 24.5, 10: 21.5, 12: 19.0, 15: 15.9, 20: 12.1 },
  200:  { 7: 33.8, 8: 30.6, 10: 26.8, 12: 23.7, 15: 19.8, 20: 15.0 },
  250:  { 7: 42.2, 8: 38.3, 10: 33.5, 12: 29.6, 15: 24.8, 20: 18.8 },
  315:  { 7: 53.0, 8: 48.2, 10: 42.1, 12: 37.3, 15: 31.2, 20: 23.6 }
};

export const ISO_8573_MAP = {
  particle: { 'P+A': 4, 'P+A+S': 2, 'P+A+S+U': 1, 'P+A+S+H': 1 },
  water: { 3: 4, '-20': 2, '-40': 1, '-70': 1 },
  oil: { 'P+A': 3, 'P+A+S': 1, 'P+A+S+U': 0, 'P+A+S+H': 0 }
};

export const STORAGE_KEY = 'kompresorHesapGecmisi_v6';

// 🔥 YENİ: VSD / İNVERTERLİ KOMPRESÖR YAPILANDIRMASI
export const VSD_CONFIG = {
  costPremium: { small: 1.25, medium: 1.20, large: 1.15 },
  energySavings: {
    high_load: { min: 0.85, max: 0.95, desc: '%85-95 yük: %5-15 tasarruf' },
    medium_load: { min: 0.70, max: 0.85, desc: '%70-85 yük: %15-30 tasarruf' },
    low_load: { min: 0.50, max: 0.70, desc: '%50-70 yük: %30-50 tasarruf' },
    very_low: { min: 0.30, max: 0.50, desc: '<%50 yük: %50-70 tasarruf' }
  },
  partLoadEfficiency: {
    1.0: 1.00, 0.9: 0.97, 0.8: 0.93, 0.7: 0.88,
    0.6: 0.82, 0.5: 0.75, 0.4: 0.67, 0.3: 0.58
  },
  tankReductionFactor: 0.8,
  maintenance: {
    fixed: { annualCostFactor: 0.03, expectedLife: 12 },
    vsd: { annualCostFactor: 0.035, expectedLife: 15 }
  },
  roi: { electricityInflation: 0.15, discountRate: 0.10, analysisPeriod: 10 },
  // ✅ YENİ: VSD Headroom (Rahat Çalışma) Faktörü
  headroom: {
    enabled: true,           // Headroom mantığını aktif et
    factor: 1.08,            // VSD için FAD'ı %8 artır (örn: 12 → 13.2 → 14 m³/dk)
    minLoadTarget: 0.70,     // Hedef: VSD en az %70 yükte çalışsın
    maxLoadTarget: 0.90      // Hedef: VSD en çok %90 yükte çalışsın
  }
};

export const calculateVSDSavingRatio = (loadRatio) => {
  if (loadRatio >= 0.85) return { min: 0.05, max: 0.15, avg: 0.10 };
  if (loadRatio >= 0.70) return { min: 0.15, max: 0.30, avg: 0.22 };
  if (loadRatio >= 0.50) return { min: 0.30, max: 0.50, avg: 0.40 };
  return { min: 0.50, max: 0.70, avg: 0.60 };
};

export const getVSDCostPremium = (totalKW) => {
  if (totalKW < 22) return VSD_CONFIG.costPremium.small;
  if (totalKW <= 75) return VSD_CONFIG.costPremium.medium;
  return VSD_CONFIG.costPremium.large;
};

export const getVSDPartLoadEfficiency = (loadRatio) => {
  const ratios = Object.keys(VSD_CONFIG.partLoadEfficiency).map(Number).sort((a, b) => b - a);
  const closest = ratios.find(r => loadRatio >= r) || ratios[ratios.length - 1];
  return VSD_CONFIG.partLoadEfficiency[closest];
};

// ✅ YENİ: VSD için headroom'lu FAD hesapla
export const calculateVSDTargetFlow = (baseFAD, kompresorTipi) => {
  if (!VSD_CONFIG.headroom.enabled || kompresorTipi !== 'vsd') return baseFAD;
  return baseFAD * VSD_CONFIG.headroom.factor;
};